<section class="mb-6">
  <form class="flex items-center gap-4" role="search">
    <div class="relative w-[32rem]">
      <label [attr.for]="searchInputId" class="sr-only">Encontre um curso</label>
      <l-icon class="absolute left-4 top-1/2 -translate-y-1/2 text-lSecondary">search</l-icon>
      <input
        [id]="searchInputId"
        type="text"
        [(ngModel)]="searchTerm"
        [name]="searchInputName"
        (input)="onSearchTermChange(searchTerm)"
        placeholder="Encontre um curso"
        class="w-full pl-12 pr-4 py-2 rounded-3xl bg-lGray900 text-lWhite text-lg border border-lGray600 focus:outline-none focus:border-lPrimary"
      />
    </div>
    <l-course-filter
      [categories]="categories"
      [selectedCategories]="selectedCategories"
      [selectedType]="selectedType"
      [selectedLocation]="selectedLocation"
      showTypeFilter
      showLocationFilter
      (filterApplied)="onFiltersApplied($event)"
    />
  </form>
</section>

<ul class="flex w-full flex-wrap items-center gap-2 mb-4">
  @for (category of selectedCategories; track $index) {
    <li>
      <span class="inline-flex items-center min-h-8 px-3 py-1 rounded-full bg-lGray700 text-lWhite text-sm leading-none">
        <span>{{ category.name }}</span>
        <button type="button" class="ml-1.5 inline-flex" (click)="removeCategory(category)">
          <l-icon class="text-sm leading-none cursor-pointer">close</l-icon>
        </button>
      </span>
    </li>
  }
  @if (showFacetChips && selectedType) {
    <li>
      <span class="inline-flex items-center min-h-8 px-3 py-1 rounded-full bg-lGray700 text-lWhite text-sm leading-none">
        <span>Tipo: {{ getTypeLabel(selectedType) }}</span>
        <button type="button" class="ml-1.5 inline-flex" (click)="removeType()">
          <l-icon class="text-sm leading-none cursor-pointer">close</l-icon>
        </button>
      </span>
    </li>
  }
  @if (showFacetChips && selectedLocation) {
    <li>
      <span class="inline-flex items-center min-h-8 px-3 py-1 rounded-full bg-lGray700 text-lWhite text-sm leading-none">
        <span>Localização: {{ getLocationLabel(selectedLocation) }}</span>
        <button type="button" class="ml-1.5 inline-flex" (click)="removeLocation()">
          <l-icon class="text-sm leading-none cursor-pointer">close</l-icon>
        </button>
      </span>
    </li>
  }
</ul>
